import React, { useEffect, useState } from "react";
import { fetchApi } from "../Utils/Fetch";
import { ReactSelectStyle } from "../Style/ReactSelect";
import Select from "react-select";
import { useTranslation } from "react-i18next";
import { useStoreCountry } from "../Contexts/StoreCountryContext";

function Navbar() {
  const { i18n, ready } = useTranslation();
  const { store } = useStoreCountry();
  const [availableLanguages, setAvailableLanguages] = useState([]);
  useEffect(() => {
    async function getAvailableTerms() {
      const languageOptions = [
        { value: "it", label: i18n.t("Italian") },
        { value: "en", label: i18n.t("English") },
        { value: "fr", label: i18n.t("French") },
        { value: "ar", label: i18n.t("Arabic") },
        { value: "ru", label: i18n.t("Russian") },
        //{ value: 'ca', label: i18n.t('Catalan') },
        //{ value: 'cs', label: i18n.t('Czech') },
        { value: "de", label: i18n.t("German") },
        { value: "es", label: i18n.t("Spanish") },
        //{ value: 'fl', label: i18n.t('Flemish') },
        { value: "jp", label: i18n.t("Japanese") },
        { value: "ko", label: i18n.t("Korean") },
        { value: "kr", label: i18n.t("Korean") },
        { value: "zh", label: i18n.t("Simplified Chinese") },
        { value: "zh_hk", label: i18n.t("Traditional Chinese") },
      ];
      if (store && i18n.resolvedLanguage) {
        var availableTerms = await fetchApi(`available-terms`, {
          method: "GET",
          query: { store: store },
        });
        console.log(i18n.resolvedLanguage);
        setAvailableLanguages(
          languageOptions.filter((l) => availableTerms.includes(l.value))
        );
        if (!availableTerms.includes(i18n.resolvedLanguage)) {
          await i18n.changeLanguage("en");
        }
      } else {
        setAvailableLanguages(languageOptions);
      }
    }
    getAvailableTerms();
  }, [store, i18n.resolvedLanguage]);

  const onChangeLanguage = async (option) => {
    var locales = await fetchApi(`locales/${option.value}`, { method: "GET" });
    i18n.addResourceBundle(option.value, "translation", locales);
    if (store) {
      try {
        var terms = await fetchApi(`terms/${option.value}`, {
          method: "GET",
          query: { store: store },
        });
        i18n.addResourceBundle(option.value, "translation", terms);
      } catch (err) {
        console.error(err);
      }
    }
    await i18n.changeLanguage(option.value);
  };
  if (ready)
    var currentLanguage = ready
      ? availableLanguages.find((l) => l.value === i18n.resolvedLanguage)
      : availableLanguages.find((l) => l.value === "en");
  return (
    <div style={{ backgroundColor: "#F7F5F1" }}>
      {" "}
      <div style={{ className: "container" }}>
        <div
          style={{
            // width: 1440,
            right: 0,
            height: 5.27,
            left: 0,
            top: 0,
            position: "absolute",
            background: "#C3B0A5",
          }}
        />
        <div
          style={{
            // width: 1440,
            right: 0,
            height: 1.32,
            left: 0,
            top: 3.95,
            position: "absolute",
            background: "#9D5248",
          }}
        />
        <div
          style={{
            // width: 1440,
            right: 0,
            height: 1.32,
            left: 0,
            top: 0,
            position: "absolute",
            background: "#9D5248",
          }}
        />
      </div>
      <div
        className="d-flex justify-content-end m-2"
        style={{ flex: 1, backgroundColor: "#F7F5F1" }}
      >
        <div key={currentLanguage?.value || "en"}>
          {ready ? (
            <Select
              value={currentLanguage}
              onChange={onChangeLanguage}
              styles={ReactSelectStyle}
              options={availableLanguages}
              className="language-select"
            />
          ) : (
            <Select
              placeholder=""
              styles={ReactSelectStyle}
              className="language-select"
            />
          )}
        </div>
      </div>{" "}
      <nav
        className="navbar navbar-expand-lg navbar-light"
        style={{ backgroundColor: "#F7F5F1" }}
      >
        <div className="container">
          <span className="navbar-brand mx-auto p-4">
            <img
              src="/assets/brand/Loro-Piana_Logo-174U.png"
              alt=""
              width="208"
              height="44"
            ></img>
          </span>
        </div>
      </nav>
    </div>
  );
}

export default Navbar;
